<template>
	<div  id='homemessage'>
		<div class='main-mybody' style="height: 100%;overflow-y: auto;">
			<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" hideRequiredMark>
				<!-- <a-form-model-item label="">
					<a-radio-group v-model="form.asktype" >
						<div style="position: relative;width: 90%;">
							<a-radio :value="item.value*1" v-for='(item,ind) in yeararr' :key='ind+"vbs"'>
								{{item.text}}
							</a-radio>
						</div>
					</a-radio-group>
				</a-form-model-item> -->
				<div class="moreViewBottom">
					<div class="dow_div" style="border-bottom:1px solid #efefef;padding:10px;">
						<div style="margin-right: auto;display: flex; align-items: center;">
							<a-checkbox v-model="selectAll" @change="onCheckAllChange(selectAll)"></a-checkbox>
							<span style="margin-left: 30px;font-size:0.835rem">全選</span>
						</div>
						<div style="width: 60px;height:25px;display: flex;align-items: center;">
							<img src="../../../image/dow.png" @click='resetForm(1)' style="margin-right:15px;cursor: pointer; width: 20px; height: 20px;" v-if="selectAll">
							<el-image style="width: 20px; height: 22px;" :src="ck" :preview-src-list="srcList" v-if="selectAll"></el-image>
							<!-- <img src="../../../image/ck.png" @click="showImageModal" style="cursor: pointer;" v-if="selectAll"> -->
						</div>
					</div>
					<div class="dow_div" style="border-bottom:1px solid #efefef;padding:10px;" v-for="(item,index) in moreCheckOption" :key="item.label">
						<div style="margin-right: auto;display: flex; align-items: center;">
							<a-checkbox :checked="item.checked" @change="onChange(index,item.checked,record)"></a-checkbox>
							<span style="margin-left: 30px;font-size:0.835rem">{{item.label}}</span>
						</div>
						<span  style="margin-right:40px;font-size:0.835rem">{{item.timeDate}}</span>
						<div style="width: 60px;height:25px;display: flex;align-items: center;">
							<img src="../../../image/dow.png" @click='resetForm(2,item)' style="margin-right:15px;cursor: pointer;width: 20px; height: 20px;" v-if="item.checked">
							<el-image style="width: 20px; height: 22px;" :src="ck" :preview-src-list="[item.yesImgUrl]" v-if="item.checked"></el-image>
							<!-- <img src="../../../image/ck.png" @click="showImageModal" style="cursor: pointer;" v-if="item.checked"> -->
						</div>
					</div>
					<!-- <a-row type="flex" justify="space-between" style='width:100%;'>
						<a-col :span='10' v-for="(item,index) in moreCheckOption" :key="item.label">
							<div class="moreCheckList">
								<a-checkbox :style="{marginRight: 'auto'}" :checked="item.checked"
									@change="onChange(index,item.checked,record)"></a-checkbox>
								<p >{{item.label}}</p>
								<div>
									<img :src="item.imgUrl" @click="imgShowEvent(record,item.yesImgUrl)" alt='加載失敗'>
								</div>
							</div>
							<div class="imgShow" v-show="record.imgShowbol" @click="record.imgShowbol = false">
								<img :src="record.showImg">
							</div>
						</a-col>
					</a-row> -->
				</div>
			</a-form-model>
		</div>
		<!-- <div v-if="imageModalVisible" class="imgShow">
			<a-icon style="color:#fff;font-size:50px;cursor: pointer;z-index:100" type="left" @click="showNextImage(1)"></a-icon>
			<img class="img_div_tc" :src="currentImage">
			<a-icon style="color:#fff;font-size:50px;cursor: pointer;;z-index:100" type="right" @click="showNextImage(2)"></a-icon>
		</div> -->
		<!-- 			<input type="checkbox" >12</input> -->
		<!-- <div class='warp_mess'>
			<button class='btn1 btnx' @click='resetForm("1")'>下載</button>
		</div> -->	
	</div>
</template>

<script>
	import ck from '../../../image/ck.png';
	import App from '@/assets/app.js';
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
    import { saveFileToLink } from 'web-downloadfile';
	
	export default {
		props: ['pared', 'record'],
		components: {ck},
		data() {
			return {
				ck:ck,
				imageModalVisible: false,
				currentImageIndex: 0,
				selectAll: true,
				visible: true,
				srcList: [],
				moreFzOption: [],
				moreCheckOption: [],
				wjMessArr: [{
						label: "香港通行證正面",
						value: "HK_TW_MacaoPassimage",
						checked: true,
						imgUrl: require("@/image/hk/xtz.png")
					},
					{
						label: "香港通行證背面",
						value: "HK_TW_MacaoPassimage2",
						checked: true,
						imgUrl: require("@/image/hk/xtb.png")
					},
					{
						label: "大陸居民身份證正面",
						value: "identificationimage",
						checked: true,
						imgUrl: require("@/image/hk/zsz.png")
					},
					{
						label: "大陸居民身份證背面",
						value: "identificationimage2",
						checked: true,
						imgUrl: require("@/image/hk/zsb.png")
					},
					{
						label: "護照",
						value: "passportimage",
						checked: true,
						imgUrl: require("@/image/hk/huzhao.png")
					},
					{
						label: "外國居民身份證正面",
						value: "identificationimage_foreign",
						checked: true,
						imgUrl: require("@/image/hk/wz.png")
					},
					{
						label: "外國居民身份證背面",
						value: "identificationimage_foreign2",
						checked: true,
						imgUrl: require("@/image/hk/wb.png")
					},
					{
						label: "香港居民身份證正面",
						value: "identificationimage_HK",
						checked: true,
						imgUrl: require("@/image/hk/xsz.png")
					},
					{
						label: "香港居民身份證背面",
						value: "identificationimage_HK2",
						checked: true,
						imgUrl: require("@/image/hk/xsb.png")
					},
					{
						label: "地址證明文件",
						value: "addressimage",
						checked: true,
						imgUrl: require("@/image/hk/address.png")
					},
					{
						label: "匯款單",
						value: "transferAccountsimage",
						checked: true,
						imgUrl: require("@/image/hk/huikuan.png")
					},
				],
				form: {
					"type": 1, 
					"asktype": 1, 
				},
			}
		},
		computed: {
			currentImage() {
				return this.moreCheckOption[this.currentImageIndex].yesImgUrl;
			}
		},
		mounted() {
			this.moreEvent()
		},
		methods: {
			showImageModal() {
				this.imageModalVisible = true;
			},
			closeImageModal() {
				this.imageModalVisible = false;
			},
			showNextImage(val) {
				if (val == 1) {
					this.currentImageIndex = (this.currentImageIndex - 1) % this.moreCheckOption.length;
				}else{

					this.currentImageIndex = (this.currentImageIndex + 1) % this.moreCheckOption.length;
				}
			},
			onCheckAllChange(checked){
				console.log(this.moreCheckOption);
				if (checked) {
					this.moreCheckOption.forEach((item, index) => {
						item.checked = true
					})
					// this.selectedOptions = this.options.slice();
				} else {
					this.moreCheckOption.forEach((item, index) => {
						item.checked = false
					})
				}
			},
			downPic(record){
			    let useMess = record.moreCheckOption;
			    useMess.forEach((ele)=>{
			        if(ele.checked){
			            saveFileToLink(ele.yesImgUrl,ele.label,'png');
			        }
			    });
			},
			onChange(index,bol,record){
			    this.moreCheckOption[index].checked = !bol;
				for (let i = 0; i < this.moreCheckOption.length; i++) {
					const val = this.moreCheckOption[i];
					if (!val.checked) {
						this.selectAll = false
						return
					}else{
						this.selectAll = true
					}
				}
			},
			imgShowEvent(record, imgUrl) {
				record.imgShowbol = true;
				record.showImg = imgUrl;
				console.log(imgUrl)
			},
			containsHttp(str) {
				return str.includes("http");
			},
			moreEvent(record = this.record) {
				let _this = this;
				// if (record.schedule == 4 && record.status == 0 && !record.aduit) {
				// 	App.oTool.warningT("開戶審核已完成");
				// 	return;
				// }
				// if (record.status == 2) {
				// 	App.oTool.warningT("開戶審核已取消");
				// 	return;
				// }
				// if(record.websiteflag != 0 && record.finishflag ==1 &&_this.form.admintype =='khadmin1'){
				//     App.oTool.warningT("沒有可用操作");
				//     return;
				// }

				if (!record.moreShowBol) {
					let json = {
						token: _this.$store.state.token,
					}
					https.fetchPost(apiUrl.getOpeningList, {
						khid: record.pdfcode
					}, json).then((data) => {
						if (Object.is(data.qmiscode, 1000)) {
							let arr = [];
							let useMess = data.picList;
							// this.srcList = useMess.map(obj => Object.values(obj)[0]);
							this.srcList = [];
							useMess.forEach((ele) => {
								for (var a in ele) {
									if (ele[a] && this.containsHttp(ele[a])) {
										ele.indexStr = a;
										ele.url = ele[a];
										
									}else{
										ele.time = ele[a];
									}
								}
								console.log(ele.indexStr);
								_this.wjMessArr.forEach((eld) => {
									if (eld.value == ele.indexStr) {
										eld.yesImgUrl = ele.url;
										eld.timeDate = ele.time;
										arr.push(eld);
										this.srcList.push(ele.url);
									}
								});
							});
							console.log(this.srcList);
							_this.moreFzOption = [{
									text: '中文名稱',
									value: data.cn_name
								},
								{
									text: '英文名稱',
									value: data.en_name
								},
								{
									text: '電話號碼',
									value: data.phonenum
								},
								{
									text: '電郵地址',
									value: data.email
								},
								{
									text: '身份信息',
									value: data.id_number
								},
								{
									text: '地址信息',
									value: data.address
								},
							];
							console.log(arr)
							_this.moreCheckOption = arr;

							_this.visible_bold = true
						} else {
							App.oTool.warningT(data.qmismsg);
						}
					}).catch(err => {
						console.log(err);
					});
				} else {
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
					record.moreShowBol = false;
				}
			},
			resetForm(val,ele_val) { 
				if (val == 1) {
					let useMess = this.moreCheckOption;
					useMess.forEach((ele)=>{
						if(ele.checked){
							saveFileToLink(ele.yesImgUrl,ele.label,'png');
						}
					});
				}else{
					saveFileToLink(ele_val.yesImgUrl,ele_val.label,'png');
				}
			},
			// this.$emit('child', 0)
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	 .el-image-viewer__img{
		max-width: 75% !important;
		max-height: 75% !important;
	}
	.dow_div{
		display: flex;
		align-items: center;
		width: 100%;
	}
	#homemessage {
		// .ant-checkbox-inner {
		//     border-radius: 50%;
		// 	}
		// .ant-checkbox-inner::after {
		//     top: 57%;
		//     left: 30%;
		//     width: 7.714286px;
		//     height: 7.714286px;
		//     border-radius: 100%;
		//     background: #fff;
		// 	outline: none;
		// 	}
		// 	.ant-checkbox-checked .ant-checkbox-inner{
		// 		border-radius: 50%;
		// 	}
		 .imgShow {
		    position: fixed;
		    width: 100vw;
		    height: 100vh;
		    left: 0vw;
		    top: 0vh;
		    background-color: rgba(0, 0, 0, 0.3);
		    z-index: 99;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		}
		.imgShow .img_div_tc{
			width: 30vw;
		    margin: 0 20px;
		    background-color: #fff;
		}
		
		.warp_mess{
			text-align: right !important;
			// text-align: center;
			margin-bottom: .3rem;
			padding: .5rem 0;
		}
		
		.moreViewBottom {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			/* border: 1px #f3f3f3 solid; */
			border-radius: 4px;
			width: 100%;
			/* padding:4px 0.5rem; */
			/* padding: 0 0 0.8rem; */
		}

		.moreViewBottom .moreCheckList {
			padding: 1rem 0rem 0.8rem 0.8rem;
			display: flex;
			align-items: center;
			width: 100%;
			// border-bottom: 1px #f3f3f3 solid;
			cursor: pointer;
		}

		.moreViewBottom .moreCheckList:last-child {
			border: none;
		}

		.moreViewBottom .moreCheckList div {
			width: 15%;
		}

		.moreViewBottom .moreCheckList img {
			width: 1.2rem;
		}

		.moreViewBottom .moreCheckList p {
			width: 70%;
			font-size: 0.835rem;
			color: #474747;
			margin: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .6rem;
		}

		.ant-form-item label {
			font-size: 0.8rem !important;
			width: 4rem;
			margin-bottom: .3rem;
		}

		.ant-form-item-children {
			font-size: 0.8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
